module.exports = __webpack_public_path__ + "img/station-wagon.ed84c028.webp";